import { render } from "./Index.vue?vue&type=template&id=52c68074&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=52c68074&scoped=true&lang=scss"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c68074"]])

export default __exports__